module.exports = __webpack_public_path__ + "static/media/mobile_signup.bc3527c1.png";